import { LoggingService } from "ionic-logging-service";
import { logging_config } from "./logging-config";

export function configureLogging(loggingService: LoggingService): () => void {
    return () => loggingService.configure(logging_config);
}